import * as React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router';

export interface IAuthRouteProps {
    isLoggedIn?: boolean;
    path: string;
    component: React.ComponentClass;
}

export class AuthRouteImpl extends React.Component<IAuthRouteProps, {}> {
    constructor(props: IAuthRouteProps) {
        super(props);
    }

    public render() {
        const { isLoggedIn, path, component } = this.props;
        return isLoggedIn ? <Route path={path} component={component} /> : <Redirect to={`/?redirect=${path}`} />;
    }
}
export function mapStateToProps(state) {
    return {
        isLoggedIn: state.login.get('isLoggedIn')
    };
}
export const AuthRoute = connect<{}, {}, IAuthRouteProps>(mapStateToProps)(AuthRouteImpl);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/AuthRoute.tsx